import React from "react";
import Merchant from "domain/merchant";
import { Dropdown } from "react-bootstrap";
import NavbarMenuToggle from "common/ui/NavbarMenuToggle";
import { useDispatch } from "react-redux";
import { changeActiveMerchant } from "./login.action";


export interface MerchantPickerProps {
    merchants: Merchant[];
    activeMerchant: Merchant;
}
 
const MerchantPicker: React.FC<MerchantPickerProps> = (props: MerchantPickerProps) => {
    const dispatch = useDispatch();

    return props.merchants.length > 1 && (
        <Dropdown className="merchant-picker">
            <Dropdown.Toggle as={NavbarMenuToggle} id="merchant-toggle" showArrow>
                {props.activeMerchant.name}
            </Dropdown.Toggle>
            <Dropdown.Menu>
                {props.merchants.filter(m => m.id !== props.activeMerchant.id)
                    .map(m => <Dropdown.Item 
                        onClick={() => changeActiveMerchant(dispatch, m)}
                        key={m.id}>
                            {m.name}
                        </Dropdown.Item>
                    )
                }
            </Dropdown.Menu>
        </Dropdown>
        );
}

export default MerchantPicker;